import Image from "next/image"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Grid from "@mui/material/GridLegacy"
import IconButton from "@mui/material/IconButton"
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { articleLink, maxString, stripTags } from "../../config/helpers";
import ParseHtml from "../../Custom/ParseHtml";
import dayjs from 'dayjs';
import Card from "@mui/material/Card"
import useWindowSize from "../../_hooks/useWindowSize"
import Link from "next/link";
import StyledBox from "@components/Custom/Box/StyledBox"
// import ArticleCardImage from "../Home2/HomeComponent2/ArticleCardImage"

const ArticleContainer = ({ type, article }) => {
    const { width, isMobile } = useWindowSize()
    const article_content_reduced = maxString(stripTags(article.content), 300);
    // const ratio = width < 768 ? 5/6 : 7/11; 
    const ratio = 16 / 4;
    return (<>
        <Card
            sx={{
                minHeight: {
                    xs: '625px',
                    md: '735px'
                }
            }}
            className="p-0 w-100">
            <Link shallow={true} href={articleLink(type, article.date, article.slug)}>
                <Grid container item xs={12} md={12}>
                    <Box sx={{
                        minHeight: {
                            xs: 300,
                            sm: 600,
                            md: 500,
                        },
                        objectFit: 'cover',
                        width: '100%',
                    }} className="position-relative">
                        <Image
                            style={{
                                paddingLeft: 0,
                                paddingRight: 0,
                                objectFit: 'cover'
                            }}
                            src={article.image}
                            alt={article.title}
                            title={article.title}
                            priority={true}
                            fill
                            quality={100}
                            sizes="(max-width: 768px) 100vw,
                         (max-width: 1200px) 50vw"
                        />
                        <Box sx={{
                            backgroundColor: 'primary.main',
                            color: 'primary.contrastText',
                            position: 'relative',
                            left: '2%',
                            top: '2%',
                            width: '50px',
                            maxWidth: '50px'
                        }} className="floating-calendar text-center p-2">
                            <Typography className="f-size_4">{dayjs(article.date).format('DD')}</Typography>
                            <Typography className="f-size_4">{dayjs(article.date).format('MMM')}</Typography>
                        </Box>
                    </Box>

                </Grid>
            </Link>
            <Box
                sx={{
                    paddingLeft: {
                        xs: '10px',
                        md: '16px',

                    },
                    paddingRight: {
                        xs: '10px',
                        md: '16px',

                    },
                }}
            >
                <Link href={articleLink(type, article.date, article.slug)}>
                    <Typography className="mt-3" variant="h4" component="h3">
                        {article.title}
                    </Typography>
                    <Typography component="p" className="mt-2">
                        <Typography component="span">Post by: </Typography>
                        <Typography component="i" color="primary">{article.display_name}</Typography>
                        <Typography color="grey" className="ml-3" component="span">{dayjs(article.date).format('DD/MM/YYYY')}</Typography>
                    </Typography>
                </Link>

                <Box>
                    <Typography className="fw-light f-size_2 mt-2">
                        <ParseHtml html={article_content_reduced} />
                    </Typography>
                </Box>

                <Box className='position-relative fit-content pb-3'>
                    <Link href={articleLink(type, article.date, article.slug)}>
                        <StyledBox className="d-flex mt-4">
                            <IconButton className="p-0" color="primary" variant="contained" aria-label="Read Article">
                                <NavigateNextIcon />
                            </IconButton>
                            <Typography className="fw-bold" color="primary">
                                Read Full Article
                            </Typography>
                        </StyledBox>
                    </Link>
                </Box>
            </Box>

        </Card>
    </>);
}

export default ArticleContainer